import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChainEnum } from '@shared/types/wallet-chain.type';
import { MemeDashboardStatusService } from '@src/app/modules/meme-dashboard/meme-dashboard-status.service';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { tadaAnimation } from 'angular-animations';
import { MemeDashboardService } from '../../../../meme-dashboard.service';

interface DateRangeOption {
    label: string;
    value: string;
}

@Component({
    selector: 'app-token-treemap',
    templateUrl: './token-treemap.component.html',
    styleUrls: ['./token-treemap.component.less'],
    animations: [tadaAnimation()],
})
export class TokenTreemapComponent implements OnInit, OnDestroy {
    ChainEnum = ChainEnum;
    smartMoneyChecked = true;
    myWatchListChecked = true;

    dateRangeList: DateRangeOption[] = [
        { label: '1h', value: '1h' },
        { label: '4h', value: '4h' },
        { label: '1d', value: '1d' },
        { label: '7d', value: '7d' },
    ];

    dateRange = '1h';

    selectedSubscribedWatchlist: number = null;

    valueType: 'smart_buy' | 'watchlist' = 'smart_buy';

    bounceStatus = true;
    bounceInterval: any;

    get userAuthenticated() {
        return this.walletStatusService.isWalletConnected || this.tgService.isTGLogin;
    }

    get isWatchListAdded() {
        return this.walletStatusService.userProfile?.watchlist?.address_added;
    }

    get mySubscribedWatchlist() {
        return this.memeDashboardStatusService.mySubscribedWatchlistAgents$.getValue();
    }

    constructor(
        public memeDashboardService: MemeDashboardService,
        public memeDashboardStatusService: MemeDashboardStatusService,
        private commonService: CommonService,
        private walletStatusService: WalletStatusService,
        private router: Router,
        private tgService: TelegramService
    ) {}

    ngOnInit() {
        if (!this.walletStatusService.isWalletConnected && !this.tgService.isTGLogin) {
            this.myWatchListChecked = false;
        }

        this.restoreTreemapDataSourceStatus();

        this.bounceInterval = setInterval(() => {
            this.bounceStatus = !this.bounceStatus;
        }, 3000);
    }

    ngOnDestroy() {
        clearInterval(this.bounceInterval);
    }

    goWatchList() {
        if (this.walletStatusService.isWalletConnected || this.tgService.isTGLogin) {
            this.router.navigate(['/meme-dashboard', 'my-watchlist']);
        } else {
            this.commonService.showLogInModal();
        }
    }

    subscribedWatchlistChange() {
        this.myWatchListChecked = false;
        this.smartMoneyChecked = false;
    }

    private restoreTreemapDataSourceStatus() {
        if (localStorage.getItem('ss_meme_smart_money_hidden')) {
            this.smartMoneyChecked = false;
        } else {
            this.smartMoneyChecked = true;
        }

        if (localStorage.getItem('ss_meme_my_watchlist_hidden')) {
            this.myWatchListChecked = false;
        } else {
            this.myWatchListChecked = true;
        }

        if (localStorage.getItem('ss_meme_subscribed_watchlist')) {
            this.selectedSubscribedWatchlist = parseInt(localStorage.getItem('ss_meme_subscribed_watchlist')) || null;
        }
    }
}
